import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { SchedulerStageApiService } from '../../../../views/scheduler-stage/api/view.service';
import { QualityControlSubWorkOrder } from '../../../../common/quality-control/model/sub-work-order-qc.ts';
import { SchedulerSubWorkOrder } from '../../../../common/scheduler/models/sub-work-order';

@Injectable()
export class HosesSchedulerStageApiService extends SchedulerStageApiService {
  getSchedulerData(
    stageName: string
  ): Observable<QualityControlSubWorkOrder[]> {
    return this.departmentApiRouter
      .getOneByName(this.departmentService.NAME)
      .pipe(
        switchMap((dep) => {
          const query = new URLSearchParams({
            stage: stageName,
            quantityOut: 'true',
            // includeInspection: 'true',
          });
          return this.schedulerApiRouter.getByTypeAndStage(
            dep.id,
            query.toString()
          );
        }),
        map((res: SchedulerSubWorkOrder[]) => {
          return this.transformItemToWorkOrder(res);
        })
      );
  }
}
